Vue.component("resource_qa_panel", {
  props: {
    resourse_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      applicationId: '',
      frameId: ''
    }
  },
  watch: {
    resourse_id: {
      handler: function (val) {
        if (!val) return
        this.init(val)
      },
      immediate: true
    },
  },
  methods: {
    init(content_id) {
      const that = this
      that.loading = true
      API.reqResoureProcess({ content_id }).then(res => {
        if (res.error_code == 'sc-terminator-service.0000.0000' && res.extend_message && (res.extend_message.ready == null || res.extend_message.ready == -1)) {
          //返回null不显示
          that.$emit('if_show', false)
        } else {
          that.$emit('if_show', true)
          if (res.error_code == 'sc-terminator-service.0000.0000' && res.extend_message && res.extend_message.ready == 1) {
            //成功
            const { application_id } = res.extend_message
            that.applicationId = application_id
            API.reqQaList({ application_id }).then(res => {
              if (res.error_code == 'sc-terminator-service.0000.0000' && res.extend_message.length) {
                that.frameId = res.extend_message[0].id
              } else {
                that.frameId = '新对话'
              }
              that.loading = false
            })
          } else {
            setTimeout(() => {
              that.init(content_id)
            }, 2 * 1000);
          }
        }
      })
    }
  },
  template: `
  <div v-loading="loading" style="width: 100%;height: 100%;overflow: hidden;">
      <iframe v-if="!loading" :src="'/terminator/resource/chat?studentLearn=true&id=' + applicationId + '&frameId=' + frameId" style="width: 100%;height: 100%;" frameborder="0"></iframe>
  </div>
`
});